<template>
  <div class="login-wrap">
    <div class="w w1200 header_logo">
      <el-image class="logo" @click="$router.push('/')" :src="logo" fit="contain">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div class="middle w w1200">
      <el-row>
        <el-col :span="12">
          <el-image class="login-banner" :src="require('../assets/img/reg.jpg')" fit="contain"></el-image>
        </el-col>
        <el-col :span="12">
          <div class="form-box">
            <div class="login-text">注册</div>
            <el-form :model="form" status-icon :rules="rules" ref="form">
              <el-form-item prop="mobile">
                <el-input type="text" maxlength="11" v-model="form.mobile" autocomplete="off" placeholder="手机号码"></el-input>
              </el-form-item>
              <el-form-item prop="smsCode">
                <el-input type="text" maxlength="6" v-model="form.smsCode" autocomplete="off" placeholder="验证码">
                  <template slot="append">
                    <button type="button" class="btn-sms" :disabled="totalTime !== 60" @click="sendSmsCode">{{ totalTime === 60 ? '发送验证码' : `${totalTime}s后重发` }}</button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="newPassword">
                <el-input type="password" v-model="form.newPassword" autocomplete="off" placeholder="新密码"></el-input>
              </el-form-item>
              <el-form-item prop="repeatPassword">
                <el-input type="password" v-model="form.repeatPassword" autocomplete="off" placeholder="确认密码"></el-input>
              </el-form-item>
              <el-form-item>
                <div class="agrreUserText">点击注册表示同意<router-link to="/userAgreement">《用户服务协议》</router-link></div>
                <el-button class="btn-login" type="primary" block round :loading="loading" @click="submitLoginPassword">确定注册</el-button>
              </el-form-item>
            </el-form>
            <div class="operation-box">
              <router-link tag="span" class="link" to="/login">已经注册？立即登录</router-link>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="footer_info" v-if="copyrights">
      <p>{{ copyrights.copyrightInformation }}</p>
      <p><a href="http://www.beian.miit.gov.cn/" target="_blank">{{ copyrights.icp }}</a></p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {sendSms, forgotPwd, register} from "../api/xunyou";
export default {
  name: 'register',
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      timer: null,
      totalTime: 60,
      form: {
        mobile: null,
        newPassword: null,
        repeatPassword: null,
        bizId: null,
        smsCode: null
      },
      rules: {
        mobile: [
          { required: true, pattern: /^1[3456789]\d{9}$/, message: '请正确输入手机号码', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, min: 6, max: 6, message: '请正确输入验证码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, min: 6, max: 16, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/, message: '密码长度6~16位，其中数字，字母和符号至少包含两种', trigger: 'blur' }
        ],
        repeatPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    logo() {
      return this.$store.state.logo;
    },
    copyrights () {
      return this.$store.state.copyrights;
    }
  },
  methods: {
    sendSmsCode () {
      this.$refs.form.validateField('mobile', valid => {
        if (valid) return;
        this.timeCountdown();
        sendSms({
          TemplateCode: 'REG',
          phoneNumbers: this.form.mobile
        }).then(res => {
          console.log('发送验证码：', res);
          if (res.Code === 'OK') {
            this.form.bizId = res.BizId;
          } else {
            this.$message.error(res.Message);
            this.totalTime = 0;
          }
        }).catch(err => {
          console.error('错误：', err);
          this.totalTime = 0;
        });
      });
    },
    timeCountdown () {
      this.totalTime -= 1;
      if (this.totalTime <= 0) {
        clearTimeout(this.timer);
        this.totalTime = 60;
      } else {
        this.timer = setTimeout(this.timeCountdown, 1000);
      }
    },
    submitLoginPassword () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          register({
            username: this.form.mobile,
            photo: this.form.mobile,
            bizId:this.form.bizId,
            validateCode: this.form.smsCode,
            password: this.form.newPassword,
          }).then(res => {
            if (res.code === 0) {
              this.$message.success('已成功注册！');
              this.$router.replace('/login');
            } else {
              this.loading = false;
              this.$message.error(res.msg);
            }
          }).catch(err => {
            console.error('错误：', err);
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    }
  }
}
</script>

<style scoped lang='less'>
.header_logo {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 0;
  height: 80px;
  .logo {
   height: 100%;
  }
}
.middle{
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgba(238,238,238,0.4);
  font-size: 0;
  overflow: hidden;
  margin-top: 30px;
  .login-banner{
    width: 100%;
    height: auto;
  }
  .form-box{
    font-size: 14px;
    padding: 0 80px;
    box-sizing: border-box;
  }
  .login-text{
    font-size: 2em;
    font-weight: bold;
    text-align: center;
    padding: 50px 0;
  }
  .btn-login{
    width: 100%;
    margin-top: 40px;
  }
  .operation-box{
    text-align: right;
    cursor: pointer;
    .link:hover{
      color: var(--main-theme-color);
      text-decoration: underline;
    }
  }
  /deep/ .el-input-group__append{
    padding: 0;
    border: none;
  }
  .btn-sms{
    width: 110px;
    height: 40px;
    background-color: var(--main-theme-color);
    color: #FFFFFF;
    border: none;
    appearance: none;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    &[disabled]{
      color: #333333;
      background-color: #eeeeee;
    }
  }
}
.footer_info {
  text-align: center;
  font-size: 12px;
  padding: 10px;
  color: #888888;
  margin-top: 20px;
  a{
    color: #888888;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/register.vue